import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import SvgIcon from '../svg-icon/svg-icon';

import css from './index.scss';
import messages from './messages';
import { Warning2, Sent, Unsent } from '../../helpers/icon-dictionary';

const SendEmailResult = (props) => {
    const { sendingEmailsResult, fatalError, onCloseModal } = props;
    const { successfulSending, alreadyVerifiedEmails, duplicateEmails, invalidRequests } = sendingEmailsResult;

    const failedEmailMessage = () => {
        const notSent = alreadyVerifiedEmails + duplicateEmails + invalidRequests;
        const notValid = (duplicateEmails + invalidRequests === 0) ? null :
            (<li className={css.comment}>
                {invalidRequests + duplicateEmails} {props.intl.formatMessage(messages.notValidOrDuplicate)}
            </li>);
        const alreadyVerified = (alreadyVerifiedEmails === 0) ? null :
            (<li className={css.comment}>
                {alreadyVerifiedEmails} {alreadyVerifiedEmails > 1 ?
                    props.intl.formatMessage(messages.emailsAlreadyVerified) :
                    props.intl.formatMessage(messages.emailAlreadyVerified)}
            </li>);

        return notSent === 0 ? null :
            (
                <div className={css.row}>
                    <div className={css.icon}>
                        <SvgIcon icon={Unsent} />
                    </div>
                    <div className={css.message}>
                        <div className={css.mainItem}>
                            {`${notSent} ${notSent > 1 ?
                                props.intl.formatMessage(messages.emailsNotSent) :
                                props.intl.formatMessage(messages.emailNotSent)}`
                            }
                        </div>
                        <ul>
                            {notValid}
                            {alreadyVerified}
                        </ul>
                    </div>
                </div>
            );
    };

    const errorBody = (
        <div className={css.error}>
            <div className={css.row}>
                <div className={css.icon}>
                    <SvgIcon icon={Warning2} />
                </div>
                <div className={css.message}>
                    <div className={css.mainItem}>{props.intl.formatMessage(messages.unableToSend)}</div>
                    <div className={css.mainItem}>{props.intl.formatMessage(messages.tryAgain)}</div>
                </div>
            </div>
        </div>
    );

    const successBody = (
        <div>
            <div className={css.row}>
                <div className={css.icon}>
                    <SvgIcon icon={Sent} />
                </div>
                <div className={css.message}>
                    <div className={css.mainItem}>{`${successfulSending} ${successfulSending > 1 ?
                        props.intl.formatMessage(messages.emailsSent) :
                        props.intl.formatMessage(messages.emailSent)}`}
                    </div>
                </div>
            </div>
            {failedEmailMessage()}
        </div>
    );

    return (
        <div className={css.confirmationMessageContainer}>
            <div className={css.title}>{props.intl.formatMessage(messages.sendEmails)}</div>
            <div className={css.recordsMessage}>
                {fatalError ? errorBody : successBody}
            </div>
            <div>
                <button
                    className={css.okButton}
                    onClick={onCloseModal}
                >{props.intl.formatMessage(messages.ok)}
                </button>
            </div>
        </div>
    );
};

SendEmailResult.propTypes = {
    sendingEmailsResult: PropTypes.object,
    fatalError: PropTypes.bool,
    onCloseModal: PropTypes.func,
    intl: intlShape.isRequired
};

export default injectIntl(SendEmailResult);



// WEBPACK FOOTER //
// ./app/components/send-email-result/index.js